<template>
  <div>
    <div
      v-if="getEnhancedDisplayProduct"
      class="productDescription__descriptionWrapper"
    >
      <!-- wrapping div needed for layout-->
      <div class="productDescription__descriptionWrapper__mobileAltImages">
        <EnhancedProductMobileCarousel
          v-if="
            getEnhancedZoomerImages &&
              getEnhancedZoomerImages.LargeSize.length > 1
          "
        />

        <!-- Pass zoom-mobile boolean property to the ProductImage component to enable dialog zoom -->
        <ProductImage
          :zoom-mobile="true"
          v-if="
            getEnhancedZoomerImages &&
              getEnhancedZoomerImages.LargeSize &&
              getEnhancedZoomerImages.LargeSize.length < 2
          "
        />
        <!-- mobile only product-options -->
        <!-- <div class="productDescription__mobileOptions">
          <ProductOptions />
        </div>-->
      </div>

      <!-- tablet only title, sku and logo -->
      <div class="productDescription__tabletTitleSkuLogo">
        <h1 class="productDescription__title">
          <span>{{ getEnhancedProductTitle }}</span>
        </h1>
        <!-- <ProductSeriesAndSku /> -->
        <ProductBrandLogos class="productDescription__tabletBrandLogo" />
      </div>

      <!-- Product Zoomer -->
      <div
        class="productDescription__descriptionWrapper__desktopTabletAltImages productDescription__productImageAndOptions"
      >
        <ProductZoomer
          v-if="
            getEnhancedZoomerImages &&
              getEnhancedZoomerImages.LargeSize &&
              getEnhancedZoomerImages.LargeSize.length > 0
          "
          :base-images="getEnhancedZoomerImages"
          :base-zoomer-options="zoomerOptions"
          :showOverlay="true"
        >
        </ProductZoomer>
        <!-- <ProductZoomer
          v-else
          :base-images="getEnhancedZoomerImages"
          :base-zoomer-options="zoomerOptions"
        /> -->

        <!-- tablet only product-options -->
        <div class="productDescription__tabletOptions">
          <!-- <ProductOptions
            v-if="!showEnhancedOption"
            :dropDownId="'tablet-drop-down'"
          />-->
          <ProductOptionsContainer :deviceType="'tablet'" />
        </div>
      </div>

      <!-- title, sku, logo and description text -->
      <div class="productDescription__titleSkuLogoAndDescription">
        <div class="productDescription__titleSkuAndLogoWrapper">
          <h1 class="productDescription__title">
            <span>{{ getEnhancedProductTitle }}</span>
          </h1>
          <!-- <ProductSeriesAndSku /> -->
          <ProductBrandLogos class="productDescription__mobileBrandLogo" />
          <ProductBannerCopy class="productBanner" deviceType="mobile-" />
        </div>
        <div class="productDescription__mobileOptions">
          <!-- <ProductOptions
            v-if="!showEnhancedOption"
            :dropDownId="'mobile-drop-down'"
          />-->
          <ProductOptionsContainer :deviceType="'mobile'" />
        </div>
        <!-- tablet only full width of screen divider -->

        <ProductBrandLogos class="productDescription__desktopBrandLogo" />

        <ProductCertification class="productCertification_desktop" />
        <div
          class="productDescription__overview productDescription__overview-mobile"
        >
          <ProductDrawerNew
            heading="Overview &amp; Features"
            drawerClass="productDescription__drawerContainer"
          >
            <ProductCertification />
            <ProductDescriptionText
              class="productDescription__descriptionText"
            />
            <ProductLink class="productDescription__productLink" />
          </ProductDrawerNew>
        </div>
        <div
          class="productDescription__overview productDescription__overview-desktop"
        >
          <ProductDescriptionText class="productDescription__descriptionText" />
          <ProductLink class="productDescription__productLink" />
        </div>
      </div>
      <!-- desktop only product-options -->
      <div class="productDescription__desktopOptions">
        <!-- <ProductOptions
          v-if="!showEnhancedOption"
          :dropDownId="'desktop-drop-down'"
        />-->

        <ProductOptionsContainer :deviceType="'desktop'" />
      </div>
    </div>
    <div v-if="!getEnhancedDisplayProduct && getEnhancedProductData">
      <p>You don't have access to this product</p>
    </div>

    <ProductSpecifications />
    <ProductResources />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
// import ProductSeriesAndSku from "./ProductEnhancedSeriesAndSku";
import ProductBrandLogos from "./ProductEnhancedBrandLogos";
import ProductDescriptionText from "./ProductEnhancedDescriptionText";
import ProductCertification from "../product/ProductCertification.vue";
import ProductImage from "../product/ProductImage";
// import ProductOptions from "../product/ProductOptions";
import ProductLink from "../product/ProductLink";
import ProductZoomer from "../product/ProductZoomer";
import EnhancedProductMobileCarousel from "./EnhancedProductMobileCarousel";
import ProductOptionsContainer from "../Enhanced/ProductOptionsContainer";
// import PositionCard from "../Enhanced/ModalOptionPositionCard";
// import ProductDrawer from "../product/ProductDrawer";
// import ProductShowMore from "../product/ProductShowMore";
import ProductSpecifications from "../product/ProductSpecifications";
import ProductResources from "../product/ProductResources";
import ProductBannerCopy from "../product/ProductBannerCopy";
import ProductDrawerNew from "../product/ProductDrawerNew.vue";

export default {
  data() {
    return {
      images: {
        Thumbs: [],
        NormalSize: [],
        LargeSize: []
      },
      zoomerOptions: {
        zoomFactor: 3,
        pane: "pane",
        hoverDelay: 300,
        namespace: "container-zoomer",
        move_by_click: true,
        choosed_thumb_border_color: "#25c0d0",
        scroller_position: "bottom",
        zoomer_pane_position: "right"
      }
    };
  },
  computed: {
    ...mapGetters("enhancedproduct", [
      "getEnhancedProductData",
      "getEnhancedDisplayProduct",
      "getEnhancedProductTitle",
      "getEnhancedZoomerImages"
    ]),
    ...mapGetters("drawer", ["getOverviewAndFeatures", "getScreenWidth"]),
    getZoomerImages() {
      if (
        this.getBomImages &&
        this.getBomImages.LargeSize &&
        this.getBomImages.LargeSize.length > 0
      ) {
        return this.getBomImages;
      } else {
        return this.getEnhancedZoomerImages;
      }
    }
  },
  components: {
    // ProductSeriesAndSku,
    ProductBrandLogos,
    ProductDescriptionText,
    ProductImage,
    ProductCertification,
    // ProductOptions,
    ProductLink,
    ProductZoomer,
    EnhancedProductMobileCarousel,
    ProductOptionsContainer,
    // PositionCard
    // ProductDrawer,
    // ProductShowMore,
    ProductDrawerNew,
    ProductSpecifications,
    ProductResources,
    ProductBannerCopy
  },
  methods: {
    toggleCompatibleProducts() {
      this.$store.dispatch("drawer/toggleOverview");
    }
  }
};
</script>

<style lang="scss" scoped>
.productDescription {
  &__descriptionWrapper {
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(lg) {
      flex-direction: row;
      padding-bottom: 60px;
    }
    &__mobileAltImages {
      display: block !important;
      @include media-breakpoint-up(md) {
        display: none !important;
      }
      @include media-breakpoint-up(lg) {
        display: none !important;
      }
    }
    &__desktopTabletAltImages {
      display: none !important;
      @include media-breakpoint-up(md) {
        display: flex !important;
      }
      @include media-breakpoint-up(lg) {
        display: flex !important;
      }
    }
  }
  &__productImageAndOptions {
    display: flex;
    justify-content: space-between;
    @include media-breakpoint-up(lg) {
      display: block;
      margin-right: 31px;
      width: 25%;
      .scroller-at-bottom {
        margin-right: 0px !important;
        width: 100% !important;
      }
    }
    @include media-breakpoint-up(md) {
      display: flex;
      margin-bottom: 28px;
      .scroller-at-bottom {
        margin-right: 25px;
        width: 50%;
      }
    }
  }
  &__productImage {
    @include media-breakpoint-up(sm) {
      margin: 0;
      margin-bottom: 30px;
      margin-right: 28px;
    }
    @include media-breakpoint-up(lg) {
      width: 100%;
    }
  }

  &__title {
    color: $gray-darker;
    font-size: 20px;
    font-family: $font-family-sans-serif-medium;
    font-weight: 500;
    letter-spacing: 0.25px;
    margin: 0;
    text-align: left;
    line-height: 1.25em;
    @include media-breakpoint-up(sm) {
      font-size: 24px;
    }
    @include media-breakpoint-up(lg) {
      font-size: 28px;
    }
  }

  &__titleSkuAndLogoWrapper {
    // margin-bottom: 20px;
    // border-bottom: 3px solid $gray;
    border-radius: 0;
    @include media-breakpoint-up(sm) {
      display: none;
    }
    @include media-breakpoint-up(lg) {
      margin-bottom: 22px;
      display: block;
      order: 0;
      border-bottom: 1px solid $gray;
      border-radius: 0;
      padding-bottom: 18px;
    }
  }

  &__titleSkuLogoAndDescription {
    display: flex;
    flex-direction: column;
    @include media-breakpoint-up(lg) {
      width: 50%;
      margin: 0 31px 0 0;
    }
  }

  &__tabletTitleSkuLogo {
    display: none;
    @include media-breakpoint-up(sm) {
      display: flex;
      flex-direction: column;
    }
    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

  &__mobileBrandLogo {
    text-align: left;
    margin-bottom: 15px;

    display: flex;
    flex-direction: column;
    align-items: flex-start;

    @include media-breakpoint-up(lg) {
      margin-bottom: 0;
      display: none;
    }
  }

  &__mobileOptions {
    @include media-breakpoint-up(md) {
      display: none;
    }
  }

  &__tabletBrandLogo {
    text-align: left;
    margin-bottom: 20px;
    margin-top: 20px;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-end;

    @include media-breakpoint-up(lg) {
      margin-bottom: 0;
      display: none;
    }
  }

  &__tabletOptions {
    display: none;
    @include media-breakpoint-up(sm) {
      display: block;
      flex-grow: 2;
      width: 50%;
    }
    @include media-breakpoint-up(lg) {
      display: none;
    }
  }

  &__desktopBrandLogo {
    display: none;
    @include media-breakpoint-up(lg) {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-end;
      text-align: left;
    }
  }

  &__desktopOptions {
    display: none;
    @include media-breakpoint-up(lg) {
      width: 400px;
      display: block;
      min-width: 400px;
    }
  }

  &__descriptionText {
    text-align: left;
  }
  &__productLink {
    text-align: left;
  }

  &__fullWidthDivider {
    display: block;
    height: 1px;
    background: $black-33;
    border-radius: 0px;
    // @include full-screenwidth-element;
    width: 100vw;
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: -50vw;
    margin-right: -50vw;
    margin-bottom: 16px;
    @include media-breakpoint-up(lg) {
      display: none;
    }
  }
}

.productDescription__overview {
  display: none;
}

.productBanner {
  @include media-breakpoint-up(lg) {
    display: none;
  }
  @include media-breakpoint-between(xs, md) {
    display: block;
  }
}

@include media-breakpoint-between(xs, md) {
  .productDescription__overview.productDescription__overview-mobile {
    display: block;
  }
}

@include media-breakpoint-up(lg) {
  .productDescription__overview.productDescription__overview-desktop {
    display: block;
  }
}

.productCertification_desktop {
  @include media-breakpoint-up(xs) {
    display: none;
  }
  @include media-breakpoint-up(sm) {
    display: none;
  }
  @include media-breakpoint-up(lg) {
    display: block;
  }
}
</style>
